import React, { Fragment } from "react";
import { connect } from "react-redux";
import { Layout, Table, Row, Col, Typography, Tag, Descriptions, Checkbox, Spin, Popover, notification, Button, Tooltip, Radio } from 'antd';
import { getEmployee } from "services/employee-service";
import { getUserBalance, getStatement, getCorporateStatement, getCorporateBalance } from "services/user-service";
import { getCorporateAccount } from "services/card-service";
import { Header, FormatMoney, FormatDate, LoadingText, UserBalance } from "components";
import { useNavigate, useParams } from "react-router-dom";
import { formatDate, formatMoney, getCountryByCode } from "utils";
import { CopyOutlined, DownloadOutlined, EnvironmentOutlined, PrinterOutlined } from '@ant-design/icons';
import { translate } from 'config/language';
import { PdfReportModal } from "components/report/PdfReportModal";
import * as XLSX from "xlsx";

const { Footer, Content } = Layout;
const { Text } = Typography;

const mapStateToProps = (state) => ({
    login: state.authReducer.loginReducer
});

const DataFetch = {
    data: [],
    loadingBalance: false,
    loadingUser: false,
    loadingStatement: false
}

const UserStatementScreen = (props) => {
    const { login } = props;
    const [data, setData] = React.useState(DataFetch)
    const [filter, setFilter] = React.useState([])
    const [page, setPage] = React.useState(1)
    const [loadingPage, setLoadingPage] = React.useState(1)
    const [loadingCopy, setLoadingCopy] = React.useState(false)
    const [printShow, setPrintShow] = React.useState(false)
    const [viewMode, setViewMode] = React.useState('pf')
    const [hasCorporateCard, setHasCorporateCard] = React.useState(false)
    const [loadingAccount, setLoadingAccount] = React.useState(false)
    const { id } = useParams();
    const navigate = useNavigate();

    const loadBalance = async (mode, withAccountLoading = false) => {
        setData((x) => ({ ...x, loadingBalance: true }));
        if (withAccountLoading) setLoadingAccount(true);
        const balance = mode === 'pj' ? await getCorporateBalance(id) : await getUserBalance(id);
        setData((x) => ({ ...x, loadingBalance: false, balance }));
        if (withAccountLoading) setLoadingAccount(false);
    }

    const load = async () => {
        setData((x) => ({ ...x, loadingBalance: true, loadingStatement: true, loadingUser: true }));
        loadBalance('pf');
        getEmployee(id).then(userData => setData((x) => ({ ...x, loadingUser: false, user: userData, swap: prepareIds(userData) })));
        getCorporateAccount(id).then(corporateAccount => {
            setHasCorporateCard(!!corporateAccount);
            if (corporateAccount) {
                setData((x) => ({ ...x, corporateAccount }));
            }
        });
        getStatementUser();
    }

    React.useEffect(() => {
        load();
    }, [])

    React.useEffect(() => {
        onFilter();
    }, [filter])

    React.useEffect(() => {
        if (page > 1)
            getStatementUser()
    }, [page])

    const getStatementUser = async (currentPage = page, currentMode = viewMode) => {
        setLoadingPage(true)
        const fetcher = currentMode === 'pj' ? getCorporateStatement : getStatement;
        const statement = await fetcher(id, currentPage);
        const statementAux = currentPage === 1
            ? statement
            : [...(data.statement ? data.statement : []), ...statement];
        setData((x) => ({ ...x, loadingStatement: false, statement: statementAux, data: insertLoad(statementAux) }))
        setLoadingPage(false)
    }

    const onViewModeChange = (e) => {
        const mode = e.target.value;
        setViewMode(mode);
        setPage(1);
        setData((x) => ({ ...x, statement: [], data: [] }));
        loadBalance(mode, true);
        getStatementUser(1, mode);
    }

    const getAllStatement = async () => {
        const fetcher = viewMode === 'pj' ? getCorporateStatement : getStatement;
        const statement = await fetcher(id, null);
        return statement
    }

    const prepareIds = (userData) => {
        return [
            { user: userData.externalKey, balanceAccount: userData.account, company: userData.companyExternal.externalKey }
        ]
    }

    const onChangeTransactionLink = (id, event) => {
        let checked = event.target.checked
        let filterAux = [...filter]
        if (checked)
            filterAux.push(id)
        else {
            const index = filterAux.indexOf(id);
            filterAux.splice(index, 1);
        }
        setFilter(filterAux)
    }

    const onFilter = () => {
        if (filter.length > 0) {
            let dataFilter = []
            for (let id of filter) {
                let links = data.statement.filter((t) => t.id == id)[0].transactionLink
                dataFilter = [...dataFilter, ...data.statement.filter((t) => t.id == id || links.includes(t.id))]
            }
            setData((x) => ({ ...x, data: dataFilter }))
        }
        else {
            setData((x) => ({ ...x, data: insertLoad(data.statement) }))
        }
    }

    const insertLoad = (statement) => {
        if (statement) {
            let statementAux = [...statement]
            statementAux.push({
                id: "Carregar mais...",
                load: true
            })
            return statementAux
        }
        return statement
    }

    const sharedOnCell = (_, index) => {
        if (index === data.statement.length) {
            return {
                colSpan: 0,
            };
        }

        return {};
    };

    const loadMore = () => {
        if (!loadingPage) {
            setPage(page + 1)
        }
    }

    const getContentValues = (row) => {
        return row.amountClearedNet != undefined && row.amountExpired != undefined ?
            <div style={{ width: 300 }}>
                <Row gutter={3}>
                    <Col sm={16}>Transação confirmada:</Col>
                    <Col sm={8}>{row.cleared ? 'Sim' : 'Não'}</Col>
                </Row>
                <Row gutter={3}>
                    <Col sm={16}>Valor já confirmado:</Col>
                    <Col sm={8}><FormatMoney value={row.amountClearedNet}></FormatMoney></Col>
                </Row>
                <Row gutter={3}>
                    <Col sm={16}>Transação expirada:</Col>
                    <Col sm={8}>{row.expired ? 'Sim' : 'Não'}</Col>
                </Row>
                <Row gutter={3}>
                    <Col sm={16}>Valor expirado:</Col>
                    <Col sm={8}><FormatMoney value={row.amountExpired}></FormatMoney></Col>
                </Row>
            </div>
            :
            <div>
                <p>Sem Detalhes!</p>
            </div>
    }

    const getAddressValues = ({ country, city, houseNumber, postalCode }) => {
        if (!country && !city && !houseNumber && !postalCode) {
            return (
                <div>
                    <p>Sem Endereço associado!</p>
                </div>
            );
        }
        return (
            <div style={{ width: 300 }}>
                {country && (
                    <Row gutter={3}>
                        <Col sm={16}>País :</Col>
                        <Col sm={8}>{country}</Col>
                    </Row>
                )}
                {city && (
                    <Row gutter={3}>
                        <Col sm={16}>Cidade :</Col>
                        <Col sm={8}>{city}</Col>
                    </Row>
                )}
                {houseNumber && (
                    <Row gutter={3}>
                        <Col sm={16}>Número :</Col>
                        <Col sm={8}>{houseNumber}</Col>
                    </Row>
                )}
                {postalCode && (
                    <Row gutter={3}>
                        <Col sm={16}>Código postal :</Col>
                        <Col sm={8}>{postalCode}</Col>
                    </Row>
                )}
            </div>
        );
    };
    const createCsv = (arr, header) => {
        let csvContent = "";
        let h = header.join("\t") + "\n";
        csvContent += h

        for (let data of arr) {
            let d = Object.values(data).join("\t")
            csvContent += d + "\n";
        }

        return csvContent
    }

    const copy = async () => {
        setLoadingCopy(true)
        const statement = await getAllStatement()
        var transactions = []
        for (let t of statement) {
            if (!t.notBalance) {
                transactions.push({
                    "Estabelecimento": t.name,
                    "Data": t.date ? formatDate(t.date, "DD/MM/YYYY HH:MM") : "",
                    "Valor": t.valueAuthorized ? ((t.reversal || t.name == "Carga" ? '' : '-') + (formatMoney(Math.abs(t.valueAuthorized) / 100, false))) : 0,
                    "Estorno": t.amountExpired > 0 ? (formatMoney(t.amountExpired - t.partialClearing, false)) : "",
                    "Cartão": t.cardNumber ? t.cardNumber : ""
                })
            }
        }
        let header = ["Estabelecimento", "Data", "Valor", "Estorno", "Cartão"]
        let csv = createCsv(transactions, header)
        navigator.clipboard.writeText(csv);
        notification.success({ message: `${translate('statement')} copiado para a área de transferência` });
        setLoadingCopy(false)
    }
    const saveFileResume = (ws_data, name, title) => {
        let sheet = name;
        let wb = XLSX.utils.book_new();
        const author = login.user?.email;
        const headerInfo = [
            [`Relatório gerado em: ${formatTimestamp(new Date().getTime())}`],
            [`Relatório gerado por: ${author}`]
        ]
        wb.Props = {
            Title: title,
            Author: author,
            CreatedDate: new Date(),
        };
        wb.SheetNames.push(sheet);
        wb.SheetNames.push("Saldo");
        let ws = XLSX.utils.aoa_to_sheet(headerInfo);
        const originRow = headerInfo.length + 3;
        let wsBalance = XLSX.utils.json_to_sheet(prepareBalanceResume(), {
                cellDates: true,
                dateNF: "YYYY-MM-DD",
            });

        XLSX.utils.sheet_add_json(ws, ws_data, {
            origin: originRow,
            skipHeader: false
        });

        wsBalance["!cols"] = [
            { wch: 40 },
            { wch: 40 },
        ]

        ws["!cols"] = [
            { wch: 40 },
            { wch: 40 },
            { wch: 40 },
            { wch: 40 },
            { wch: 40 },
            { wch: 40 },
        ]
        wb.Sheets[sheet] = ws;
        wb.Sheets["Saldo"]= wsBalance;

        XLSX.writeFile(wb, sheet + ".xlsx");

    };
    const prepareBalanceResume = () => {
        let ws_data = [];
        data.balance.details.forEach(entry => {
            let tmp = { Segmentação: entry.nameBenefit, Saldo: formatMoney(entry.balance) }
            ws_data.push(tmp)
        })
        ws_data.push({ Segmentação: "Total", Saldo: formatMoney(data.balance.balance) })
        return ws_data;
    }
    const prepareFileResume = () => {
        let ws_data = [];
        data.statement.forEach(entry => {
            const status = entry.promise ? "PENDENTE" : entry.declined ? entry.declined.name.toUpperCase() : "APROVADO"
            const registerValue = ((entry.reversal || entry.name === "Carga" || entry.name === "Estorno") ? "+" : "-") + Math.abs(entry.value)
            let tmp = {
                Data: formatDate(entry.date), "Origem Transação": entry.name, Status: status, Valor: formatMoney(registerValue), Segmentação: entry.nameBenefit, Cartão: entry.cardNumber ? entry.cardNumber : ""
            };
            ws_data.push(tmp)
        })
        return ws_data;
    }
    const onResume = async () => {
        saveFileResume(prepareFileResume(), "Extrato_" + new Date().getTime(), "Resumo Extrato");
    }
    function formatTimestamp(timestamp) {
        const date = new Date(timestamp);


        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    }

    return (
        <Layout className="alymente-layout">
            <Header title={data.user?.name}>
                <Row></Row>
            </Header>
            <Content>
                {(login.company.master || hasCorporateCard) && (
                    <Row justify="center" style={{ marginBottom: 12 }}>
                        <Radio.Group value={viewMode} onChange={onViewModeChange} buttonStyle="solid" disabled={data.loadingBalance || loadingAccount}>
                            <Radio.Button value="pf">Benefício</Radio.Button>
                            <Radio.Button value="pj">Corporativo</Radio.Button>
                        </Radio.Group>
                    </Row>
                )}
                <Row style={{ marginBottom: 20 }} justify="center">
                    <UserBalance loading={data.loadingBalance} balance={data.balance} />
                </Row>
                <Descriptions labelStyle={{ fontWeight: "bold" }} column={3}>
                    <Descriptions.Item label="Company">
                        <LoadingText
                            loading={data.loadingUser || loadingAccount}
                            value={viewMode === 'pj' ? data.corporateAccount?.externalOwnerId : data.user?.companyExternal?.externalKey}
                        />
                    </Descriptions.Item>
                    <Descriptions.Item label="User">
                        <LoadingText
                            loading={data.loadingUser || loadingAccount}
                            value={viewMode === 'pj' ? data.corporateAccount?.externalHolderId : data.user?.externalKey}
                        />
                    </Descriptions.Item>
                    <Descriptions.Item label="Balance Account Group">
                        <LoadingText
                            loading={data.loadingUser || loadingAccount}
                            value={viewMode === 'pj' ? data.corporateAccount?.bagId : data.user?.account}
                        />
                    </Descriptions.Item>
                </Descriptions>
                <Table
                    scroll={{ x: 1300, y: 450 }}
                    dataSource={data.data}
                    loading={data.loadingStatement || loadingCopy || loadingAccount || loadingPage}
                    pagination={false}
                    bordered
                >
                    <Table.Column
                        align={"center"}
                        title="ID"
                        dataIndex="id"
                        key="id"
                        render={(value, row) =>
                            row.load ? (
                                <div onClick={loadMore} className="loadMore">
                                    {loadingPage || data.loadingStatement ? <Spin /> : value}
                                </div>
                            ) : (
                                value
                            )
                        }
                    />
                    <Table.Column
                        onCell={sharedOnCell}
                        align={"center"}
                        title="Data"
                        dataIndex="date"
                        key="date"
                        render={(value, data, index) => (
                            <>
                                <FormatDate value={value} format={"DD/MM/YYYY HH:mm"} />
                            </>
                        )}
                    />
                    <Table.Column
                        onCell={sharedOnCell}
                        align={"center"}
                        title={translate("statement")}
                        dataIndex="name"
                        key="name"
                        render={(value, row) => (
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                {row.service ? (
                                    <Tooltip
                                        placement="bottom"
                                        title={"Serviço: " + row.service.toUpperCase()}
                                    >
                                        {value}
                                    </Tooltip>
                                ) : (value)}
                                {row.country || row.city || row.houseNumber ||
                                    row.postalCode ? (
                                    <Popover
                                        content={getAddressValues({ ...row, country: getCountryByCode(row.country) })}
                                        title={
                                            <div>
                                                <Text>Endereço</Text>
                                            </div>
                                        }
                                    >
                                        <a style={{ color: "inherit" }} href={`https://www.google.com/maps/place/${getCountryByCode(row.country)}+${row.postalCode}/`} rel="noreferrer" target="_blank">
                                            <EnvironmentOutlined style={{ padding: "5px" }} />
                                        </a>
                                    </Popover>
                                ) : null}
                            </div>
                        )}
                    />
                    <Table.Column
                        onCell={sharedOnCell}
                        align={"center"}
                        title="Status"
                        dataIndex="benefit"
                        key="benefit"
                        render={(value, row) => (
                            <Tooltip title={row.declined ? row.declined.message : ""}>
                                <Tag
                                    style={{ whiteSpace: "normal" }}
                                    color={
                                        row.declined
                                            ? "error"
                                            : row.promise
                                                ? "warning"
                                                : "success"
                                    }
                                >
                                    {row.promise
                                        ? "PENDENTE"
                                        : row.declined
                                            ? row.declined.name.toUpperCase()
                                            : "APROVADO"}
                                </Tag>
                            </Tooltip>
                        )}
                    />
                    {/* <Table.Column onCell={sharedOnCell} align={"center"} title="Mensagem" dataIndex="code" key="code" render={(value, row) => row.declined ? row.declined.message : ""} /> */}
                    <Table.Column
                        onCell={sharedOnCell}
                        align={"center"}
                        title="MCC"
                        dataIndex="mcc"
                        key="mcc"
                    />
                    <Table.Column
                        onCell={sharedOnCell}
                        align={"center"}
                        title="Valor"
                        dataIndex="value"
                        key="value"
                        render={(value, row) => (
                            <Popover
                                content={getContentValues(row)}
                                title={
                                    <div style={{ textAlign: "center" }}>
                                        <Text>Resumo</Text>
                                    </div>
                                }
                            >
                                <Text>
                                    <FormatMoney
                                        value={
                                            ((row.reversal || row.name == "Carga" || row.name === "Estorno") ? "+" : "-") +
                                            Math.abs(value)
                                        }
                                    />
                                </Text>
                            </Popover>
                        )}
                    />
                    <Table.Column
                        onCell={sharedOnCell}
                        align={"center"}
                        title="Segmentação"
                        dataIndex="nameBenefit"
                        key="nameBenefit"
                    />
                    <Table.Column
                        onCell={sharedOnCell}
                        align={"center"}
                        title="Modo de Pagamento"
                        dataIndex="mode"
                        key="mode"
                        render={(value, row) => (
                            <Tooltip title={row.modeMessage != "" ? row.modeMessage : ""}>
                                <Text>
                                    {row.mode != null && row.mode != "" ? row.mode.name : ""}
                                </Text>
                            </Tooltip>
                        )}
                    />
                    <Table.Column
                        onCell={sharedOnCell}
                        align={"center"}
                        title="Cartão"
                        dataIndex="cardNumber"
                        key="cardNumber"
                        width={200}
                    />
                    {data.statement &&
                        data.statement.length > 0 &&
                        data.statement[0].merchantKey != undefined && (
                            <Table.Column
                                onCell={sharedOnCell}
                                align={"center"}
                                title="Merchant"
                                dataIndex="merchantKey"
                                key="merchantKey"
                            />
                        )}
                    {data.statement &&
                        data.statement.length > 0 &&
                        data.statement[0].transactionLink != undefined && (
                            <Table.Column
                                onCell={sharedOnCell}
                                align={"center"}
                                title="Transações Associadas"
                                dataIndex="transactionLink"
                                key="transactionLink"
                                render={(value, row) =>
                                    value && value.length > 0 ? (
                                        <Checkbox
                                            checked={filter.includes(row.id) ? true : false}
                                            onChange={(e) => onChangeTransactionLink(row.id, e)}
                                        />
                                    ) : (
                                        ""
                                    )
                                }
                            />
                        )}
                </Table>
            </Content>
            <Footer style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between'
            }}>
                <Button
                    className="btn-save"
                    type="primary"
                    onClick={() => navigate(-1)}>
                    Voltar
                </Button>
                <div>
                    <Button style={{ margin: 10 }}
                        loading={loadingCopy}
                        disabled={loadingCopy || data.loadingStatement}
                        type="primary"
                        icon={<PrinterOutlined />}
                        onClick={() => { setPrintShow(true) }}
                    >
                        Imprimir
                    </Button>
                    <Button style={{ margin: 10 }}
                        loading={loadingCopy}
                        disabled={loadingCopy || data.loadingStatement}
                        type="primary"
                        icon={<DownloadOutlined />}
                        onClick={() => onResume()}>Resumo</Button>
                    <Button style={{ margin: 10 }}
                        loading={loadingCopy}
                        disabled={loadingCopy || data.loadingStatement}
                        type="primary"
                        icon={<CopyOutlined />}
                        onClick={copy}
                    >
                        Copiar
                    </Button>
                </div>
            </Footer>
            <PdfReportModal sender={login.user.name} data={data} pdfModel={"statement"} printShow={printShow} setPrintShow={setPrintShow} />

        </Layout>

    );
}

export default connect(mapStateToProps, {})(UserStatementScreen);
